import { Field } from '@progress/kendo-react-form';
import React from 'react'
import { Api } from '../../redux/api/BaseApi';
import { UserApi } from '../../redux/api/UserApi';
import { IClientTypeFilter } from '../../types/User/IClientTypeFilter';
import ClientTypeList from './ClientTypeList'

export const ClientTypeFilter = () => {
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const { data: clientTypeFilters } = UserApi.useGetClientTypeFiltersQuery();
    const [saveClientTypeFilter] = UserApi.usePostClientTypeFilterMutation();
    const disabled = userProfile?.Features.Client_Type_Filter_Disabled;

    const clientTypeListChanged = (e) => {
        console.log('clientTypeListChanged', e, e.target.value)
        let currentTypeIds = clientTypeFilters?.map(ct => ct.Company_Type_Id)
        let newIds = e.value.map(ct => ct.ID)
        //Added
        e.value.map(ct => currentTypeIds.indexOf(ct.ID) === -1 && saveClientTypeFilter({ Company_Type_Id: ct.ID, Checked: true } as IClientTypeFilter))

        //Removed
        clientTypeFilters?.filter(c => c.Checked).map(cur => newIds.indexOf(cur.Company_Type_Id) === -1 && saveClientTypeFilter({ Company_Type_Id: cur.Company_Type_Id, Checked: false } as IClientTypeFilter))
    }
    return (
        <Field
            disabled={disabled}
            label={`${userProfile?.Phrases.Client} Type Filter`}
            name="cleintTtypeList"
            onChange={clientTypeListChanged}
            component={ClientTypeList}
            clientTypeIds={clientTypeFilters?.filter(c => c.Checked).map(ct => ct.Company_Type_Id)}
        />

    )
}
